module.exports = __webpack_public_path__ + "70f2ab95c66f8d6417384669dbad3ebf.png";